var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdit) ? _c('profile-info-edit') : _c('profile-info'), _vm._v(" "), _c('contract-paper', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }), _vm._v(" "), (_vm.isIdentified) ? _c('contract-status') : _c('contract-electronic', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c62fe8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/profile/Profile.vue
// module id = 940
// module chunks = 0